import { render, staticRenderFns } from "./MarketingProduct.vue?vue&type=template&id=07118f6e&scoped=true"
import script from "./MarketingProduct.vue?vue&type=script&lang=ts"
export * from "./MarketingProduct.vue?vue&type=script&lang=ts"
import style0 from "./MarketingProduct.vue?vue&type=style&index=0&id=07118f6e&prod&lang=scss&scoped=true"
import style1 from "./MarketingProduct.vue?vue&type=style&index=1&id=07118f6e&prod&lang=scss"
import style2 from "./MarketingProduct.vue?vue&type=style&index=2&id=07118f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07118f6e",
  null
  
)

export default component.exports